<template>
    <div class="text-center mt-3">
      <button
        class="btn btn-lg btn-success"
        :disabled="loading"
        @click="initierPaiement"
      >
        <i class="fas fa-credit-card"></i> 
        <span v-if="!loading"> Payer maintenant</span>
        <span v-else>Chargement...</span>
      </button>
      <p class="mt-2 text-muted" v-if="error">{{ error }}</p>
    </div>
    <!-- <p>
      {
  "portefeuille": "667999bf9be9560cc6a02392",
  "reference": "2eee3e77-3984-416f-8c49-e47da751102a",
  "redirect_success": "https://mon-espace.logistics.yams-ga.com/callback",
  "redirect_error": "https://mon-espace.logistics.yams-ga.com/operations/mes-reservations/31",
  "amount": 100,
  "disbursement": "68ac3cbcf4f5a0c869640815",
  "logoURL": "https://logistics.yams-ga.com/images/logo.png",
  "isTransfer": true
}
    </p> -->
  </template>
  
  <script>  
  import axios from 'axios'

  export default {
    name: 'PayerMaintenant',
    props: {
      demande: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        error: null
      }
    },
    methods: {
      async initierPaiement() {
        this.loading = true
        this.error = null

        try {
          const response = await axios.post('https://gateway.singpay.ga/v1/ext', {
            portefeuille: '667999bf9be9560cc6a02392',
            reference: this.demande.reference,
            redirect_success: `${window.location.origin}/callback-success`,
            redirect_error: `${window.location.origin}/operations/mes-reservations/${this.demande.id}`,
            amount: this.demande.montant,
            disbursement: "68ac3cbcf4f5a0c869640815",
            logoURL: 'https://logistics.yams-ga.com/images/logo.png',
            isTransfer: true
          }, {
            headers: {
              'x-client-id': 'fd80526e-5415-4978-988f-0783b80f18b0',
              'x-client-secret': '347270b0efb570a702a932dcb28b95a9a7165924bea87a412979e5a368ecc5bd',
              'x-wallet': '667999bf9be9560cc6a02392',
              'Content-Type': 'application/json'
            }
          })

          const lien = response.data.link
          if (lien) {
            window.location.href = lien
          } else {
            this.error = "Erreur : lien de paiement manquant."
          }
        } catch (e) {
          console.error(e)
          this.error = "Erreur lors de la tentative de paiement."
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .btn {
    min-width: 180px;
  }
  </style>
  